// @ts-nocheck
/* eslint-disable */
import { addListener } from "~/lib/signals";
import { store } from "~/state/store";
import MyMapsPopup from "~/es6/mymaps.popup";
import { _ } from "~/i18n";
import List from "./list";

class LicenceIntro {
	constructor() {
		this._dom = {
			submitButton: Mapy.Util.node("button", { type: "button" })
		};

		this._dom.submitButton.addEventListener("click", this);

		addListener(this, "licence-needed", "_buildAgreements");
		this._list = null;
	}

	_buildAgreements() {
		const documents = Mapy.getComponent("licence").needed;
		const { user } = store.getState().user;
		const logged = user.state === "green";

		let agreeText = _("licence.checkAcknowledge");
		// updatujeme cache s dokumenty
		documents.forEach(doc => {
			if (doc.acceptation === "agree") {
				agreeText = _("licence.checkAgree");
			}

			Mapy.getComponent("logger").log("conditions_impress", {
				logged,
				origin: "login",
				document_id: doc.document_id,
				document_type: doc.document_type
			});
		});

		if (this._list) {
			this._list.destroy();
		}
		this._list = new List(documents);
		// vytvorime okno
		this._popup = new MyMapsPopup({
			name: "licence",
			userClose: false
		});

		// sestavime obsah okna
		const frag = Mapy.Util.fragment();
		// hero image
		frag.appendChild(Mapy.Util.node("img", { src: "/img/gdpr.svg" }));
		frag.appendChild(Mapy.Util.node("h2", { innerHTML: _("licence.checkTitle") }));
		frag.appendChild(Mapy.Util.node("p", { innerHTML: _("licence.checkText") }));
		frag.appendChild(this._list.container);
		const toolbar = Mapy.Util.node("div", { className: "toolbar" });
		this._dom.submitButton.innerHTML = agreeText;
		toolbar.appendChild(this._dom.submitButton);
		frag.appendChild(toolbar);
		this._popup.getContainer().appendChild(frag);

		// otevreme hotove okno
		this._popup.open();
	}

	handleEvent(e) {
		switch (e.type) {
			case "click":
				if (e.target === this._dom.submitButton) {
					const { user } = store.getState().user;
					const logged = user.state === "green";

					this._popup.close();
					Mapy.getComponent("licence").setApprove(Mapy.getComponent("licence").needed.map(doc => {
						Mapy.getComponent("logger").log("condition_accepted", {
							logged,
							origin: "login",
							document_id: doc.document_id,
							document_type: doc.document_type
						});

						return doc.document_type;
					}), true);
				}
				break;
		}
	}
}

Mapy.LicenceIntro = LicenceIntro;
